import React from 'react';
import classes from "./Loader.module.scss";

const Loader = ({className,aa, isDynamicSize}) => {
  return (
    <div className={isDynamicSize ? `${classes.dynamicSizeLoader} ${className}` : aa ? `${classes.aaloader} ${className}`:`${classes.loader} ${className}`} >
    </div>
  );
};

export default Loader;
